// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_MAIN = '/main';
const ROOTS_MASTERS = '/masters';

const DistributorClaimApproval = '/DistributorClaimApproval'

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};


export const PATH_MASTERS = {
    DistributorClaimApproval,
    root: ROOTS_MASTERS,

};



export const PATH_MAIN = {
    DistributorClaimApproval,
    root: ROOTS_MAIN,
    user: path(ROOTS_MAIN, '/systemadminstration/user-group'),
    entitytype: path(ROOTS_MAIN, '/systemadminstration/entitytype'),
    newUser: path(ROOTS_MAIN, '/systemadminstration/newuser'),
    editUser: path(ROOTS_MAIN, '/systemadminstration/edituser'),
    newentity: path(ROOTS_MAIN, '/systemadminstration/newentity'),
    userRole: path(ROOTS_MAIN, '/systemadminstration/user-role'),
    editentitypage: path(ROOTS_MAIN, '/getentities/editentitypage'),
    postedfilter: path(ROOTS_MAIN, '/postedfilter/filter'),
    claimdocumentdetails: path(ROOTS_MAIN, '/report/claimdocumentdetails'),
    schemedefination: path(ROOTS_MAIN, '/schemedefination/schemedef'),
    schemeexception: path(ROOTS_MAIN, '/schemeexception/schemeexceptiondef'),
    newschemeexception: path(ROOTS_MAIN, '/schemeexception/newschemeexception'),
    newscheme: path(ROOTS_MAIN, '/scheme-defination/add'),
    EditSchemeDef: path(ROOTS_MAIN, '/scheme-defination/edit'),
    ProfileDetails : path(ROOTS_MAIN, `/user-pofile`),


   // one: path(ROOTS_MAIN, '/one'),
    master: {
        // root: path(ROOTS_MAIN),
        root: ROOTS_MAIN,
        one: path(ROOTS_MAIN, '/one'),
        two: path(ROOTS_MAIN, '/master/two'),
        three: path(ROOTS_MAIN, '/master/three'),
        four: path(ROOTS_MAIN, '/master/four'),
        five: path(ROOTS_MAIN, '/master/five'),
        six: path(ROOTS_MAIN, '/master/six'),
    },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  one: path(ROOTS_DASHBOARD, '/one'),
  two: path(ROOTS_DASHBOARD, '/two'),
  three: path(ROOTS_DASHBOARD, '/three'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    four: path(ROOTS_DASHBOARD, '/user/four'),
    five: path(ROOTS_DASHBOARD, '/user/five'),
    six: path(ROOTS_DASHBOARD, '/user/six'),
  },
}; 
